import Api from "@/services/api";

const basic = "participant";
export default {
  get(id) {
    return Api.default().get("/" + basic + "?limit=100&tripId=" + id);
  },
  put(id, param) {
    return Api.default().put("/" + basic + "/" + id, param);
  },
};
